export const TYPECIRCLARS = `/v2/guest/regulations?model=system`;
export const CIRCLARS = (id) => `/v2/guest/regulations/${id}?model=system`;
